<template>
  <section id="SectionInBank" :class="background">
    <Wrap class="lg">
      <h3 class="title">
        {{ title || $t('title') }}
      </h3>

      <Splitter :left="6" :right="6">
        <div slot="left">
          <p>{{ $t('text') }}</p>

          <ul class="bulletpoints">
            <li v-for="(item, index) in $ta('bulletpoints')" :key="index">
              {{ item }}
            </li>
          </ul>
        </div>

        <div slot="right" class="calculatorSide">
          <InBank />
        </div>
      </Splitter>
      <div class="cta">
        <Route class="Btn" :title="$t('cta')" :to="{ name: $route.name, hash: '#FooterContact' }">
          {{ $t('cta') }}
        </Route>
      </div>
    </Wrap>
  </section>
</template>

<script>
import InBank from './InBank'
import Splitter from './Splitter'

export default {
  components: {
    InBank,
    Splitter,
  },
  props: {
    background: String,
    title: String,
  },
}
</script>

<style lang="scss">
#SectionInBank {
  .title {
    margin-bottom: 3rem;
  }

  .bulletpoints {
    margin-top: 1.5rem;
    opacity: 0.8;
    padding-left: 1rem;
  }

  .cta {
    margin-top: 3rem;
    text-align: center;
    @include md {
      margin-top: 4rem;
    }
  }

  .calculatorSide {
    min-width: 300px;
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "Pirkimas išsimokėtinai su „Inbank“",
    "text": "Ypač patogiai ir greitai įsigyti norimą saulės elektrinę galite pirkdami išsimokėtinai. Jums tereikia išsirinkti tinkamiausią sprendimą, o mūsų partneris „Inbank“ jums pateiks palankiausią finansavimo pasiūlymą.",
    "bulletpoints": [
      "4,9% palūkanos;",
      "1,5% sutarties administravimo mokestis;",
      "Paskolos suma iki 15 000 eurų;",
      "Terminas 12-72 mėnesiai."
    ],
    "cta": "Gaukite pasiūlymą"
  }
}
</i18n>
